import { GzDashboardSmartViewsToolbarWebComponent } from './component/GzDashboardSmartViewsToolbarWebComponent';

export { GzDashboardSmartViewsToolbarWebComponent };
